import React from 'react';
import {
  Box,
  BoxProps,
  FormControlLabel,
  FormControlProps,
  Grid,
  GridProps,
  Switch,
} from '@mui/material';
import { useField } from 'formik';

type SparkToggleSwitchProps = {
  name: string;
  label: string;
  subLabel?: React.ReactNode;
  defaultChecked?: boolean;
  size?: GridProps['xs'];
  sx?: FormControlProps['sx'];
  onChange?: (checked: boolean) => void;
  isDisabled?: boolean;
  subHeader?: React.ReactNode;
  labelStyles?: BoxProps['sx'];
};

function SparkFormToggleSwitch({
  name,
  label,
  size = 12,
  subLabel = <></>,
  subHeader,
  sx,
  defaultChecked = false,
  isDisabled = false,
  labelStyles = {},
  onChange,
}: SparkToggleSwitchProps) {
  const [field, _, helpers] = useField<boolean>(name);

  const handleChange = (checked: boolean) => {
    helpers.setValue(checked);
    onChange && onChange(checked);
  };

  const renderLabel = () => {
    return (
      <Grid
        item
        container
        xs={12}
        display='flex'
        flexWrap='nowrap'
        alignItems='center'
        gap={2}
      >
        <Box sx={labelStyles}>{label}</Box>
        {subLabel}
      </Grid>
    );
  };

  return (
    <Grid container item xs={size} alignItems='flex-start'>
      <Box width='100%' display='flex'>
        <FormControlLabel
          control={<Switch defaultChecked={defaultChecked || field.value} />}
          label={''}
          sx={{
            ...sx,
          }}
          onChange={(_, checked) => handleChange(checked)}
          value={field.value}
          disabled={isDisabled}
        />

        {renderLabel()}
      </Box>
      {subHeader}
    </Grid>
  );
}

export default SparkFormToggleSwitch;
